import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

const STORAGE_KEY = 'dhikr_theme'

function getInitialDark(): boolean {
  if (typeof window === 'undefined') return false
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === 'dark') return true
  if (stored === 'light') return false
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

function applyDark(dark: boolean) {
  if (typeof document === 'undefined') return
  document.documentElement.classList.toggle('dark', dark)
}

export const useThemeStore = defineStore('theme', () => {
  const isDark = ref(getInitialDark())

  applyDark(isDark.value)

  watch(isDark, (dark) => {
    applyDark(dark)
    localStorage.setItem(STORAGE_KEY, dark ? 'dark' : 'light')
  }, { flush: 'sync' })

  function toggle() {
    isDark.value = !isDark.value
  }

  function setDark(dark: boolean) {
    isDark.value = dark
  }

  return { isDark, toggle, setDark }
})
